import React from 'react';

const DashboardCardSkeleton = () => {
  return (
    <div className="p-6 space-y-4 animate-pulse">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-stretch">
        <div className="bg-white flex gap-3 p-2 col-span-1 md:col-span-2 rounded h-full shadow-md">
          <div className="h-16 w-16 rounded-full bg-gray-200 shrink-0" />
          <div className="flex-1 space-y-2 py-4">
            <div className="h-4 w-24 bg-gray-200 rounded-full" />
            <div className="h-3 w-32 bg-gray-100 rounded-full" />
            <div className="h-3 w-20 bg-gray-100 rounded-full" />
          </div>
        </div>

        <div className="bg-white flex flex-col px-4 py-4 rounded h-full gap-2 shadow-md">
          <div className="h-3 w-20 bg-gray-200 rounded-full" />
          <div className="h-8 w-full bg-gray-100 rounded" />
          <div className="flex gap-2 mt-2">
            <div className="h-6 w-16 bg-gray-200 rounded" />
            <div className="h-6 flex-1 bg-gray-100 rounded" />
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#6E3EF5] to-[#40248F] flex flex-col justify-between px-3 py-6 rounded h-full shadow-md">
          <div className="space-y-2">
            <div className="h-6 w-24 bg-white/20 rounded" />
            <div className="h-3 w-32 bg-white/10 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCardSkeleton;
